import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/nPLRegionsGuests/Get`, payload),
    GetByLevel: (payload) => Repository.post(`/api/nPLRegionsGuests/GetByLevel`, payload),
    GetByParentID: (payload) => Repository.post(`/api/nPLRegionsGuests/GetByParentID`, payload),
    GetActive: (payload) => Repository.post(`/api/nPLRegionsGuests/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/nPLRegionsGuests/GetById`, payload),
}
